import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as TicketActions from './ticket.actions';
import { ITicketState } from './ticket.models';

export const TICKET_FEATURE_KEY = 'ticket';
export interface TicketPartialState {
  readonly [TICKET_FEATURE_KEY]: ITicketState;
}

const stateTypeGuard = <T>(state: T): T => state;

const reducer = createReducer(
  {} as ITicketState,
  on(
    TicketActions.initTicketState,
    TicketActions.clearTicketState,
    () => stateTypeGuard<ITicketState>({
      id: 'ticket-state',
      name: 'ticket',
    })
  ),
  on(TicketActions.loadTicketStateSuccess, (state) => stateTypeGuard<ITicketState>({
    ...state,
    isLoaded: true,
  })),
  on(TicketActions.loadTicketStateFailure, (state, { error }) => stateTypeGuard<ITicketState>({
    ...state,
    error
  })),


  /**
   * GET API Request
   */
  on(TicketActions.getCountersAPI, (state) => stateTypeGuard<ITicketState>({
    ...state,
    counters: {
      ...state.counters,
      response: undefined
    },
    error: undefined
  })),


  /**
   * GET API Response SUCCESS
   */
  on(TicketActions.getCountersAPISuccess, (state, { successResponse }) => stateTypeGuard<ITicketState>({
    ...state,
    counters: {
      ...state.counters,
      response: successResponse
    },
  })),


  /**
   * GET API Response ERROR
   */
  on(TicketActions.getCountersAPIFailed, (state, { errorResponse }) => stateTypeGuard<ITicketState>({
    ...state,
    counters: {
      ...state.counters,
      response: errorResponse
    },
    error: errorResponse
  })),
);

export function ticketReducer(state: ITicketState | undefined, action: Action) {
  return reducer(state, action);
}
